import { render, staticRenderFns } from "./orderConnectLists.vue?vue&type=template&id=508225ab&scoped=true&"
import script from "./orderConnectLists.vue?vue&type=script&lang=js&"
export * from "./orderConnectLists.vue?vue&type=script&lang=js&"
import style0 from "./orderConnectLists.vue?vue&type=style&index=0&id=508225ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508225ab",
  null
  
)

export default component.exports